module.exports = { 
    getVstopSSvetovanjemStrankaPrisotnaZavarovalecForm () {
        return {
            ime: {
                name: 'ime',
                type: 'xs:string',
                formType: 'text-input',
                required: true,
                value: undefined,
            },
            priimek: {
                name: 'priimek',
                type: 'xs:string',
                formType: 'text-input',
                required: true,
                value: undefined,
            },
            mobitel: {
                name: 'mobitel',
                type: 'xs:string',
                formType: 'phone-input',
                required: true,
                value: undefined,
            },
            email: {
                name: 'email',
                type: 'xs:string',
                formType: 'email-input',
                required: true,
                value: undefined,
            },
            potrditvenaKoda: {
                name: 'potrditvenaKoda',
                type: 'xs:string',
                formType: 'potrditvena-koda',
                required: true,
                value: undefined,
            },
            soglasjePrejemDokumentacije: {
                name: 'soglasjePrejemDokumentacije',
                type: 'checkbox',
                formType: 'checkbox-required-checked',
                required: true,
                value: false,
            },
            soglasjeUporabaEmailMobitel: {
                name: 'soglasjeUporabaEmailMobitel',
                type: 'checkbox',
                formType: 'checkbox-required-checked',
                required: true,
                value: false,
            },
            otpId: {
                name: 'otpId',
                type: 'xs:string',
                formType: 'text-input',
                required: true,
                value: undefined,
            },
        }
    }
};